
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDropzone } from 'react-dropzone'
import { getreturnedContainerBoxCreate, getreturnedContainerBoxDeletePicturesDocuments, getreturnedContainerBoxRead, getreturnedContainerBoxUpdate } from '../../store/user/actions';
import { useDispatch, useSelector } from 'react-redux';
import { resetreturnedContainerBoxCreateState } from '../../store/user/userSlice';

const BoxEditScanTwoFill = () => {
  const initialValues = {
    box_no: "",
    total_pieces: "",
    boxes: [],
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [formValues, setFormValue] = useState(initialValues);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
  const [uploadedImage, setUploadedImage] = useState(null);
  const [isDropzoneVisible, setDropzoneVisibility] = useState(true);
  const [documentFiles, setDocumentFiles] = useState([]);
  const [boxData, setBoxData] = useState(null);
  const returnedContainerBoxDeletePicturesDocuments = useSelector(state => state.returnedContainerBoxDeletePicturesDocuments)
  const returnedContainerBoxRead = useSelector(state => state.returnedContainerBoxRead)
  const returnedContainerBoxCreate = useSelector(state => state.returnedContainerBoxCreate)
  const dispatch = useDispatch()
  const params = useParams()
  // Image upload state





  const handleFileChange = (e, index) => {
    const selectedFiles = e.target.files;
    const oldFiles = [...files];
    const newFiles = []
    for (let i = 0; i < selectedFiles.length; i++) {
      newFiles.push(selectedFiles[i]);
    }
    oldFiles[index] = newFiles
    setFiles(oldFiles);
  };


  const handleDocFileChange = (e, index) => {
    const selectedFiles = e.target.files;
    const oldFiles = [...documentFiles];
    const newFiles = []
    for (let i = 0; i < selectedFiles.length; i++) {
      newFiles.push(selectedFiles[i]);
    }
    oldFiles[index] = newFiles
    setDocumentFiles(oldFiles);
  };

  const handleChange = (index, name, value) => {
    const updatedBoxes = [...formValues.boxes];
    updatedBoxes[index] = { ...updatedBoxes[index], [name]: value };
    setFormValue({ ...formValues, boxes: updatedBoxes });
  };
//   console.log(formValues);
  const handleGoBack = () => {
    navigate(-1);
  };
  const handleRemoveFile = (index, fileindex) => {
    const newFiles = [...files];
    newFiles[index].splice(fileindex, 1);

    setFiles(newFiles);
  };
  const handleRemoveServerFile = (id) => {
   dispatch(getreturnedContainerBoxDeletePicturesDocuments({id}))
  };

  const handleRemoveDocFile = (index, fileindex) => {
    const newFiles = [...documentFiles];
    newFiles[index].splice(fileindex, 1);

    setDocumentFiles(newFiles);
  };

  const createBox = () => {
    setLoading(true);
    const formData = new FormData();
    formValues.boxes.forEach((box, index) => {
      const filesForBox = files[index] || []; // Ensure files array exists
      const docFilesForBox = documentFiles[index] || []; // Ensure docFiles array exists
      for (const file of filesForBox) {
        formData.append(`boxes[${index}][pictures][]`, file); // Append images
      }
      for (const docFile of docFilesForBox) {
        formData.append(`boxes[${index}][documents][]`, docFile); // Append documents
      }
      // Append other box data
      formData.append(`boxes[${index}][box_no]`, box.box_no);
      formData.append(`boxes[${index}][id]`, box.returned_container_box_id);
      formData.append(`boxes[${index}][total_pieces]`, box.total_pieces);
    });
    formData.append("returned_container_id", params.id);
    dispatch(getreturnedContainerBoxCreate(formData)).then(() => {
      setLoading(false); // Set loading to false when request is complete
    }).catch(() => {
      setLoading(false); // Set loading to false if request fails
    });
  };
// console.log(formValues);
  useEffect(() => {
    if (returnedContainerBoxCreate.isSuccess || returnedContainerBoxCreate.status === 1) {
      // reset-pending
      dispatch(resetreturnedContainerBoxCreateState())
      navigate('/box-scan-image/'+params.id);
    }
  }, [returnedContainerBoxCreate.isSuccess, returnedContainerBoxCreate.status]);
  
  useEffect(() => {
    // const storedFormData = JSON.parse(localStorage.getItem('formData'));
   dispatch(getreturnedContainerBoxRead({ returned_container_id: params.id }));
  }, [params.id,returnedContainerBoxDeletePicturesDocuments]);
  console.log(returnedContainerBoxRead);

  useEffect(() => {
    const updatedBoxes = [...formValues.boxes];
    returnedContainerBoxRead.data.map(async(item, index) => {
        updatedBoxes[index] = { ...updatedBoxes[index], 
          "total_pieces": item.total_pieces,
          "box_no":item.box_no,returned_container_box_id:item.returned_container_box_id };
        return 1
    })
    setFormValue({ ...formValues, boxes: updatedBoxes });
    if (returnedContainerBoxRead.data) {
      setBoxData(returnedContainerBoxRead.data);
    }
  }, [returnedContainerBoxRead.data]);

  const truncateFileName = (fileName, maxLength = 5) => {
    if (fileName.length <= maxLength) {
      return fileName;
    } else {
      return fileName.substring(0, maxLength) + '...';
    }
  };
  return (
    <div>
      <div className='heading_select'>
        <div className="d-flex align-items-baseline" onClick={handleGoBack}>
          <img style={{ cursor: "pointer" }} src="/Images/arrow-left.svg" />
          <h1>Box Scan Form</h1>
        </div>
      </div>
      <div className='row'>
        {
          returnedContainerBoxRead.data.map((item, index) => {
            return <>
              <div className='col-lg-4'>
                <div className='scan_box'>
                  <div className='gray_box'>
                    BOX-{index + 1}
                  </div>

                  <div key={index} className="file-preview-container position-relative mb-2">
                    <h6 className='input_heading'>Pictures</h6>
                    <div className='d-flex file-preview'>
                    <input
                      type="file"
                      multiple
                      className="hidden-file-input"
                      onChange={(e) => handleFileChange(e, index)}
                      accept='image/*'
                    />
                    <div className='upload_image-wrap'>
                    {
                            item.returned_container_box_pictures.map((image)=> 
                           <div className='file-preview'>
                            <img src={image.file_url} className='uploaded_img'/>
                            <button onClick={() => handleRemoveServerFile(image.id)} className='close_red'><img src='/Images/redClose.svg' /></button>
                            </div>)
                        }
                      {files[index] && files[index].map((file, fileIndex) => (
                        <div className="file-preview">
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Preview ${index}`}
                          />
                          <button onClick={() => handleRemoveFile(index, fileIndex)} className='close_red'><img src='/Images/redClose.svg' /></button>
                        </div>
                      ))}
                    </div>
                    <div className='mb-2'>
                      <img src="/Images/upload_icon.svg" />
                    </div>
                  </div>
                  </div>
                  <div key={index} className="file-preview-container position-relative">
                  <h6 className='input_heading'>Documents</h6>
                  <div className='d-flex'>
                    <input
                      className="hidden-doc-input"
                      type="file"
                      multiple
                      onChange={(e) => handleDocFileChange(e, index)}
                    />
                    <div className='upload_image-wrap'>
                    {
                            item.returned_container_box_documents.map((image)=> 
                           <div>
                            <i className="fa fa-file-text-o" aria-hidden="true"></i>
                            <button onClick={() => handleRemoveServerFile(image.id)} className='close_red'><img src='/Images/redClose.svg' /></button>
                            </div>)
                        }
                 
                 
                      {documentFiles[index] && documentFiles[index].map((file, fileIndex) => (
                        <div className="file-preview">
                          <label>{truncateFileName(file.name)}</label>
                          <button onClick={() => handleRemoveDocFile(index, fileIndex)} className='close_red'><img src='/Images/redClose.svg' /></button>
                        </div>
                      ))}
                    </div>
                    <div className='mb-2'>
                    <img src="/Images/upload_icon.svg" />
                    </div>
                  </div>
                  </div>
                  <div className='mt-2 mb-2 position-relative'>
                    <label className='select-label'>Total Pieces </label>
                    <input
                      placeholder='Total Pieces'
                      className='input-custom-primary'
                      type='text' // Change type to text
                      onChange={(e) => handleChange(index, "total_pieces", e.target.value)}
                      value={formValues.boxes[index]?.total_pieces || ''}
                    />
                  </div>
                  <div className='mb-4 position-relative'>
                    <label className='select-label'>Box Number</label>
                    <input
                      placeholder='Box Number'
                      className='input-custom-primary'
                      type='text' // Change type to text
                      onChange={(e) => handleChange(index, "box_no", e.target.value)}
                      value={formValues.boxes[index]?.box_no || ''}
                    />
                  </div>
                </div>
              </div>
            </>
          })
        }

      </div>
      {/* <div className='package_butn mt-4'>
        <Link className='suffix_bag' onClick={createBox} disabled={loading} >{loading ? 'Loading...' : 'Submit'}</Link> 
        <Link to="/box-scan-image">form</Link> 
         <Link to="/primary-upload" className='suffix_bag'>Submit</Link>
      </div> */}
      <div className='package_butn sub_margin'>
          <button className='suffix_bag' onClick={createBox} disabled={loading}>{loading ? 'Loading...' : 'Submit'}</button>
        </div>
    </div>
  )
}

export default BoxEditScanTwoFill
